import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BrandLogo, BrandPanel } from './BrandPanel'

/** Giriş ve parola ekranlarının ortak iskeleti: solda marka paneli, sağda form kartı. */
export function AuthShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  return (
    <div className="relative flex min-h-dvh items-center justify-center overflow-hidden bg-background px-4 py-8 sm:px-6">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(55%_45%_at_0%_0%,color-mix(in_oklch,var(--color-brand-sky)_18%,transparent),transparent),radial-gradient(45%_40%_at_100%_100%,color-mix(in_oklch,var(--color-brand-orange)_12%,transparent),transparent)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-50 [background-image:linear-gradient(var(--color-border)_1px,transparent_1px),linear-gradient(90deg,var(--color-border)_1px,transparent_1px)] [background-size:48px_48px] [mask-image:radial-gradient(70%_60%_at_50%_50%,black,transparent)]"
      />

      <div className="relative w-full max-w-5xl">
        <div className="grid min-h-[640px] overflow-hidden rounded-3xl border border-border/70 bg-card shadow-[0_2px_4px_color-mix(in_oklab,var(--shadow-color)_4%,transparent),0_12px_24px_-8px_color-mix(in_oklab,var(--shadow-color)_8%,transparent),0_40px_80px_-24px_color-mix(in_oklab,var(--shadow-color)_28%,transparent)] lg:grid-cols-[1.05fr_1fr] dark:shadow-[0_40px_80px_-24px_color-mix(in_oklab,var(--shadow-color)_70%,transparent)]">
          <BrandPanel />
          <div className="flex flex-col px-6 py-8 sm:px-12 sm:py-12">
            <div className="flex items-center gap-3 lg:hidden">
              <BrandLogo size="sm" />
              <div className="leading-tight">
                <p className="text-lg font-bold tracking-tight">{t('app.name')}</p>
                <p className="text-xs font-medium text-muted-foreground">{t('auth.brand.subtitle')}</p>
              </div>
            </div>
            <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-8 lg:py-0">{children}</div>
          </div>
        </div>
        <p className="mt-5 text-center text-xs text-muted-foreground lg:hidden">{t('auth.brand.copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  )
}
